// src/pages/ReportIssue/components/PhotosSection.js
import React from "react";
import {
    Typography,
    Box,
    Grid,
    Paper,
    IconButton,
    Button as MuiButton
} from "@mui/material";
import {
    AddPhotoAlternate as AddPhotoIcon,
    Close as CloseIcon
} from "@mui/icons-material";

const PhotosSection = ({ photos = [], handlePhotoUpload = () => {}, removePhoto = () => {} }) => {
    return (
        <Box mb={4}>
            <Box display="flex" alignItems="center" gap={1} mb={2}>
                <AddPhotoIcon sx={{ color: '#3B82F6' }} />
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#3A5A78' }}>
                    Attach Photos (Optional)
                </Typography>
            </Box>

            <Typography variant="body2" sx={{ mb: 2, color: '#4B5563' }}>
                Upload up to 3 photos to help us better understand the issue. Clear images will help us resolve your issue faster.
            </Typography>

            <Box
                sx={{
                    border: '2px dashed #E5E7EB',
                    borderRadius: '10px',
                    p: 3,
                    textAlign: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    mb: 3,
                    '&:hover': {
                        borderColor: '#3B82F6',
                        backgroundColor: 'rgba(59, 130, 246, 0.05)'
                    }
                }}
                onClick={() => document.getElementById('photo-upload').click()}
            >
                <input
                    id="photo-upload"
                    type="file"
                    accept="image/*"
                    multiple
                    style={{ display: 'none' }}
                    onChange={handlePhotoUpload}
                />
                <AddPhotoIcon sx={{ fontSize: 48, color: '#9CA3AF', mb: 1 }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
                    Click to upload photos
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                    JPG, PNG or JPEG (max 5MB per file)
                </Typography>
                <MuiButton
                    variant="outlined"
                    component="span"
                    sx={{
                        borderRadius: '8px',
                        textTransform: 'none'
                    }}
                >
                    Browse Files
                </MuiButton>
            </Box>

            {/* Photos Preview */}
            {photos && photos.length > 0 && (
                <>
                    <Typography variant="subtitle2" sx={{ mb: 2 }}>
                        Uploaded Photos ({photos.length}/3)
                    </Typography>
                    <Grid container spacing={2} sx={{ mb: 3 }}>
                        {photos.map((photo, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <Paper
                                    elevation={0}
                                    sx={{
                                        position: 'relative',
                                        borderRadius: '10px',
                                        overflow: 'hidden',
                                        border: '1px solid #E5E7EB'
                                    }}
                                >
                                    <IconButton
                                        size="small"
                                        sx={{
                                            position: 'absolute',
                                            top: 8,
                                            right: 8,
                                            backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                            '&:hover': {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)'
                                            }
                                        }}
                                        onClick={() => removePhoto(index)}
                                    >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                    <img
                                        src={photo.preview}
                                        alt={`Preview ${index + 1}`}
                                        style={{
                                            width: '100%',
                                            height: 160,
                                            objectFit: 'cover'
                                        }}
                                    />
                                    <Box sx={{ p: 1 }}>
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                display: 'block',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }}
                                        >
                                            {photo.name}
                                        </Typography>
                                    </Box>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </>
            )}
        </Box>
    );
};

export default PhotosSection;